import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/app/App';
import * as serviceWorker from './serviceWorker';
import 'react-tooltip/dist/react-tooltip.css';

// Create a root for React 18
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component
root.render(<App />);

// Enable service worker for offline capabilities
serviceWorker.register();
